import * as React from "react";

export class TemplatePagination extends React.Component<TemplatePaginationProps, TemplatePaginationState> {
    static defaultProps: Partial<TemplatePaginationProps> = {};

    constructor(props: TemplatePaginationProps) {
        super(props);
        this.state = {};
    }

    public render() {
        let numberOfButtons=0;
        if(this.props.Size>0)
            numberOfButtons=Math.ceil(this.props.Size/9);
        let buttonList:number[]=[];

        for(let i=0;i<numberOfButtons;i++)
        {
            buttonList.push(i);
        }

        return (
            <div style={{width:'100%',textAlign:'center'}}>
                <button className={'tablePaginationItem'} disabled={this.props.Index==0} onClick={x=>this.props.PageChanged(this.props.Index-1)}>
                    {'<'}
                </button>
                {buttonList.map(x=>
                    <button key={x} className={'tablePaginationItem '+(x==this.props.Index?'active':'')} onClick={y=>this.props.PageChanged(x)}>
                        {x+1}
                    </button>

                )}
                <button className={'tablePaginationItem'} disabled={this.props.Index==numberOfButtons-1} onClick={x=>this.props.PageChanged(this.props.Index+1)}>
                    {'>'}
                </button>
            </div>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplatePaginationProps {
    Index:number;
    Size:number;
    PageChanged:(number)=>void;
}

interface TemplatePaginationState {

}

//#endregion "My Region"